import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'tanning_dressing_leather_dressing_dyeing_fur'

export const dataPointDefinition = {
  retracedId: 'tanning_dressing_leather_dressing_dyeing_fur',
  name: 'Tanning and dressing of leather; dressing and dyeing of fur',
  description:
    'This includes, e.g., tanning, dyeing and dressing of hides and skins; manufacture of chamois dressed, parchment dressed, patent or metallized leathers; manufacture of composition leather; scraping, shearing, plucking, currying, tanning, bleaching and dyeing of fur skins and hides:  This does not inc',
  meta: {
    slcpMeta: {
      key: 'fp-pro-25',
      number: 'FP-PRO-2-4',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'fp-pro-2',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'Facility Profile',
      verificationSelectionOptList: 'verf-f-list',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '[1]',
      machineShowHide: '[1]',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-pro-25', version: '1.7.0', provider: 'slcp'}],
  sortingId: 28870,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
